export default __webpack_public_path__ + "static/media/20.0f5c0813.jpg";